import { render, staticRenderFns } from "./RootUtentiView.vue?vue&type=template&id=3f6a6ad8&"
import script from "./RootUtentiView.vue?vue&type=script&lang=ts&"
export * from "./RootUtentiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports